import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button, Chips, IconArrowLeft16 } from '@cian/ui-kit';
import { FormCardFooterLayout } from '../../../components/RequestFormV2/FormCardFooterLayout';
import { FormCardLayout } from '../../../components/RequestFormV2/FormCardLayout';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { selectFlightEnabled } from '../../../selectors/meta';
import { selectQuizItemByType } from '../../../selectors/quizItems';
import { selectFormPriceRange } from '../../../selectors/requestFormV2';
import { setFormStep, setPriceRange } from '../../../slices';
import { EFormStep } from '../../../types/requestForm/requestFormV2';
import { prepareOptions, rangeToValue, valueToRange } from '../utils/range';

export const QuizPriceRangeContainer = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const quizItem = useSelector(selectQuizItemByType('prices'));
  const priceRangeValue = useSelector(selectFormPriceRange);
  const preparedOptions = React.useMemo(() => prepareOptions(quizItem.options), [quizItem.options]);
  const isFlightEnabled = useSelector(selectFlightEnabled);

  const handleChange = (value: string[]) => {
    const range = valueToRange(value[0]);
    dispatch(setPriceRange(range));
  };

  const handleNext = () => {
    dispatch(setFormStep(EFormStep.AdditionalServices));
  };

  const handleBack = () => {
    dispatch(setFormStep(EFormStep.Rooms));
  };

  if (!quizItem) {
    return null;
  }

  return (
    <FormCardLayout
      dataTestId="RequestFormV2PriceRange"
      question={quizItem.title}
      image={quizItem.image}
      imageMobile={quizItem.imageMobile}
      legend={isFlightEnabled ? 'Шаг 2 из 4' : undefined}
    >
      <>
        <Chips
          selectType="single"
          value={[rangeToValue(priceRangeValue)]}
          onChange={handleChange}
          options={preparedOptions}
        />
        <FormCardFooterLayout>
          <Button
            size="M"
            onClick={handleBack}
            theme="stroke_secondary"
            beforeIcon={<IconArrowLeft16 color="icon-primary-default" />}
          />
          {priceRangeValue && (
            <Button size="M" onClick={handleNext} theme="fill_primary">
              Дальше
            </Button>
          )}
        </FormCardFooterLayout>
      </>
    </FormCardLayout>
  );
};
